
require('./script.js');
require('../css/normalize.css');
require('../css/general.css');
require('../css/style.css');


function setPiwikCode() {
  _paq.push(['trackEvent', "foreign-stocks-intro", this.dataset.paq]);
}

function urlRedirect(url) {
  // var url = changeUrl(this);
  if (this.target === "_blank")
    window.open(encodeURI(url));
  else
    window.location.assign(encodeURI(url));
  return false;
}

// changeUrl
function setUrlParam() {
  var url = (' ' + this.href).slice(1);
  if (url.indexOf('?') === -1)
    url += '?';
  else
    url += '&';
  var strProd = getParameterByName('strProd');
  var strWeb = getParameterByName('strWeb');
  url += 'strProd=' + (strProd || '0037');
  url += '&strWeb=' + (strWeb || '0035');
  
  return url;
}

function getParameterByName(name, url) {
  if (!url) 
    url = window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
  if (!results) 
    return null;
  if (!results[2]) 
    return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}


// On document load
document.addEventListener('DOMContentLoaded', function() {

  // >_navbar.html Sinopac logo  
  var handleLogo = function() {
    var url = setUrlParam.call(this);
    return urlRedirect.call(this, url);
  }
  document.querySelector('#menu > div.company_logo > a')
    .onclick = handleLogo;
    
  // >_navbar.html Top menu / navi <a>
  var handleMenu = function() {
    setPiwikCode.call(this);
    var url = setUrlParam.call(this);
    return urlRedirect.call(this, url);
  }
  document.getElementsByClassName('nav_link')[0]
    .onclick = handleMenu;
  document.querySelector('#menu > div.menu_right_wrapper.w-hidden-medium.w-hidden-small.w-hidden-tiny > div > a:nth-child(1)')
    .onclick = handleMenu;

  document.getElementsByClassName('nav_link')[1]
    .onclick = handleMenu;
  document.querySelector('#menu > div.menu_right_wrapper.w-hidden-medium.w-hidden-small.w-hidden-tiny > div > a:nth-child(2)')
    .onclick = handleMenu;

  document.getElementsByClassName('nav_link')[2]
    .onclick = handleMenu;
  document.querySelector('#menu > div.menu_right_wrapper.w-hidden-medium.w-hidden-small.w-hidden-tiny > div > a:nth-child(3)')
    .onclick = handleMenu;

  document.getElementsByClassName('nav_link')[3]
    .onclick = handleMenu;
  document.querySelector('#menu > div.menu_right_wrapper.w-hidden-medium.w-hidden-small.w-hidden-tiny > div > a:nth-child(4)')
    .onclick = handleMenu;

  document.getElementsByClassName('nav_link')[4]
    .onclick = handleMenu;
  document.querySelector('#menu > div.menu_right_wrapper.w-hidden-medium.w-hidden-small.w-hidden-tiny > div > a:nth-child(5)')
    .onclick = handleMenu;

  document.getElementsByClassName('nav_link')[5]
    .onclick = handleMenu;
  document.querySelector('#menu > div.menu_right_wrapper.w-hidden-medium.w-hidden-small.w-hidden-tiny > div > a:nth-child(6)')
    .onclick = handleMenu;


  // >_navbar.html Account Opening
  var handleNavbarAccountOpen = function() {
    setPiwikCode.call(this);
    var url = setUrlParam.call(this);
    return urlRedirect.call(this, url);
  }
  document.querySelector('#menu > div.menu_right_wrapper.w-hidden-medium.w-hidden-small.w-hidden-tiny > a.menu_account_opening.w-inline-block')
    .onclick = handleNavbarAccountOpen;
  document.getElementsByClassName('nav_account_opening')[0]
    .onclick = handleNavbarAccountOpen;

  
  // >_navbar.html Login
  var handleNavbarLogin = function() {
    setPiwikCode.call(this);
    var url = setUrlParam.call(this);
    return urlRedirect.call(this, url);
  }
  document.querySelector('#menu > div.menu_right_wrapper.w-hidden-medium.w-hidden-small.w-hidden-tiny > a.menu_login.w-inline-block')
    .onclick = handleNavbarLogin;
  document.getElementsByClassName('nav_login')[0]
    .onclick = handleNavbarLogin;
  

  // >account-opening.html Account opening
  var handleAccountOpen = function() {
    setPiwikCode.call(this);
    var url = setUrlParam.call(this);
    return urlRedirect.call(this, url);
  }
  document.querySelector('#ac-open-process > div.ac_open_button_wrapper > a')
    .onclick = handleAccountOpen;
  document.querySelector('#ac-open-appointment > div.ac_open_appointment_column_wrapper > div.ac_open_section3_column2 > a')
    .onclick = handleAccountOpen;
});
